import { AppData, Lightning } from '@lightningjs/sdk';
import AbstractLoginModal, {
  AbstractLoginModalTemplateSpec,
  LoginFlow,
} from '../layout/AbstractLoginModal';
import ForgotPasswordContent from 'components/pages/login/forgot-password/ForgotPasswordContent';
import { WidgetNames } from 'config/routes';
import { ConfirmationType } from 'components/pages/login/confirmation/EmailConfirmationModal';

export interface ForgotPasswordModalTemplateSpec
  extends AbstractLoginModalTemplateSpec {
  Content: {
    ForgotPasswordContent: typeof ForgotPasswordContent;
  } & AbstractLoginModalTemplateSpec['Content'];
}

export default class ForgotPasswordModal
  extends AbstractLoginModal
  implements
    Lightning.Component.ImplementTemplateSpec<ForgotPasswordModalTemplateSpec>
{
  override _showBackButton = true;
  override _showSkipButton = false;

  override get loginFlow() {
    return LoginFlow.SIGN_IN;
  }

  private _ForgotPasswordContent = this._Content.getByRef(
    'ForgotPasswordContent',
  );

  static override _template(): Lightning.Component.Template<ForgotPasswordModalTemplateSpec> {
    const { Content, ...rest } = super._template();
    return {
      Content: {
        ...Content,
        flex: {
          direction: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        },
        ForgotPasswordContent: {
          type: ForgotPasswordContent,
          signals: {
            $onContentHovered: true,
            $onEmailSubmit: true,
            $openKeyboard: '$openKeyboard',
          },
        },
      },
      ...rest,
    };
  }

  modalInit(data: { email: string }) {
    this._ForgotPasswordContent.email = data?.email;
  }

  private async $onEmailSubmit(email: string) {
    const isResetLinkSent = await this.onLoading(
      AppData!.loginRadiusService!.forgotPassword(email),
    );
    if (isResetLinkSent === undefined) return;

    if (isResetLinkSent) {
      AppData?.modalService.open(
        WidgetNames.FORGOT_PASSWORD_CONFIRMATION_MODAL,
        {
          data: { email, confirmationType: ConfirmationType.FORGOT_PASSWORD },
        },
      );
    }
  }

  private $onContentHovered() {
    this._setState('Content');
  }

  override _getFocused() {
    return this._ForgotPasswordContent;
  }
}
